import React from 'react';
import { motion } from 'framer-motion';

const PageHeader = ({ title, description, bgImage = "https://images.unsplash.com/photo-1582213782179-e0d53f98f2ca?q=80&w=2940&auto=format&fit=crop" }) => {
  return (
    <div className="relative pt-24 pb-16 lg:pt-32 lg:pb-24 bg-brand-navy overflow-hidden">
      <div className="absolute inset-0 bg-cover bg-center opacity-20 mix-blend-overlay grayscale" style={{ backgroundImage: `url(${bgImage})` }} />
      <div className="absolute inset-0 bg-gradient-to-t from-brand-navy via-brand-navy/90 to-transparent" />
      
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-balance">
        <motion.div 
          initial={{ opacity: 0, y: 20 }} 
          animate={{ opacity: 1, y: 0 }} 
          transition={{ duration: 0.5 }}
          className="max-w-4xl mx-auto"
        >
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-white mb-6 tracking-tight">
            {title}
          </h1>
          {description && (
            <p className="text-lg md:text-xl text-slate-300 leading-relaxed font-medium">
              {description}
            </p>
          )}
        </motion.div>
      </div>
    </div>
  );
};

export default PageHeader;